module.exports = __webpack_public_path__ + "static/img/yoann-siloine-LiDVw7tZPfY-unsplash_thumb.1437097.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/yoann-siloine-LiDVw7tZPfY-unsplash_thumb.png
// module id = Rb/0
// module chunks = 4